import React from 'react';
import LegacyTextLink, { TextLinkProps } from './TextLink.legacy';
import AlphaTextLink from './TextLink.alpha';

const Component = process.env.IS_LEGACY ? LegacyTextLink : AlphaTextLink;
export default Component as React.FC<TextLinkProps>;
export type { TextLinkProps };
